/* ========================================
   Case Manager — Mock Data
   ======================================== */

export const clinicalAlerts = [
  {
    id: 'alert-1',
    pazienteNome: 'Rossi Maria',
    pazienteId: 1,
    tipo: 'critico',
    parametro: 'SpO2',
    valore: '88%',
    soglia: '< 92%',
    messaggio: 'Saturazione bassa rilevata alle 06:45',
    timestamp: '18/02/2026 06:45',
    letto: false,
  },
  {
    id: 'alert-2',
    pazienteNome: 'Ferrara Elena',
    pazienteId: 7,
    tipo: 'critico',
    parametro: 'Dolore (NRS)',
    valore: '8/10',
    soglia: '> 7',
    messaggio: 'Dolore severo non controllato dalla terapia',
    timestamp: '18/02/2026 07:20',
    letto: false,
  },
  {
    id: 'alert-3',
    pazienteNome: 'Bianchi Giuseppe',
    pazienteId: 2,
    tipo: 'warning',
    parametro: 'PA Sistolica',
    valore: '165 mmHg',
    soglia: '> 160',
    messaggio: 'Pressione arteriosa elevata — monitorare',
    timestamp: '18/02/2026 08:10',
    letto: false,
  },
  {
    id: 'alert-4',
    pazienteNome: 'Ricci Marco',
    pazienteId: 8,
    tipo: 'warning',
    parametro: 'Temperatura',
    valore: '37.8°C',
    soglia: '> 37.5°C',
    messaggio: 'Febbricola persistente da 2 giorni',
    timestamp: '17/02/2026 20:30',
    letto: true,
  },
];

export const expiringPAIs = [
  {
    id: 'exp-1',
    pazienteNome: 'Verdi Anna',
    pazienteId: 3,
    scadenza: '22/02/2026',
    giorniRimanenti: 4,
    tipoPAI: 'Riabilitazione Ortopedica',
    cia: 'CIA-2',
    rivalutazionePianificata: false,
  },
  {
    id: 'exp-2',
    pazienteNome: 'Marchetti Teresa',
    pazienteId: 5,
    scadenza: '25/02/2026',
    giorniRimanenti: 7,
    tipoPAI: 'Assistenza Base',
    cia: 'CIA-1',
    rivalutazionePianificata: false,
  },
  {
    id: 'exp-3',
    pazienteNome: 'Esposito Luca',
    pazienteId: 4,
    scadenza: '01/03/2026',
    giorniRimanenti: 11,
    tipoPAI: 'Infermieristica Avanzata',
    cia: 'CIA-3',
    rivalutazionePianificata: true,
  },
  {
    id: 'exp-4',
    pazienteNome: 'De Luca Concetta',
    pazienteId: 11,
    scadenza: '28/02/2026',
    giorniRimanenti: 10,
    tipoPAI: 'Cure Palliative',
    cia: 'CIA-4',
    rivalutazionePianificata: false,
  },
];

export const caseManagerTasks = [
  {
    id: 'task-1',
    mittente: 'COT Roma 2',
    tipo: 'richiesta',
    oggetto: 'Dimissione protetta — Lombardi Ennio',
    messaggio: 'Richiesta presa in carico urgente. Dimissione prevista domani.',
    timestamp: '18/02/2026 09:15',
    letto: false,
    priorita: 'alta',
  },
  {
    id: 'task-2',
    mittente: 'Caregiver Rossi',
    tipo: 'segnalazione',
    oggetto: 'Difficolta somministrazione farmaci',
    messaggio: 'La paziente rifiuta la terapia orale da 2 giorni. Richiesta visita medico.',
    timestamp: '18/02/2026 08:40',
    letto: false,
    priorita: 'media',
    pazienteId: 1,
  },
  {
    id: 'task-3',
    mittente: 'Inf. Colombo Martina',
    tipo: 'referto',
    oggetto: 'Referto visita Ferrara Elena',
    messaggio: 'CVC medicato. Segni di flogosi peristomale. Richiedere ecografia.',
    timestamp: '17/02/2026 16:20',
    letto: true,
    priorita: 'media',
    pazienteId: 7,
  },
  {
    id: 'task-4',
    mittente: 'Sistema ADI',
    tipo: 'sistema',
    oggetto: 'Accettazione provider confermata',
    messaggio: 'Coop. "Cuore di San Camillo" ha accettato la presa in carico di Bianchi Giuseppe.',
    timestamp: '17/02/2026 14:00',
    letto: true,
    priorita: 'bassa',
  },
];

/* ========================================
   Schede Paziente — Dettaglio per Case Manager
   ======================================== */
export const patientDetails = {
  7: {
    id: 7,
    nome: 'Ferrara',
    cognome: 'Elena',
    sesso: 'F',
    eta: 72,
    dataNascita: '14/06/1953',
    codiceFiscale: 'FRRLNE53H54H501Z',
    residenza: 'Via Tuscolana 312, Roma',
    telefono: '+39 06 7654321',
    medico: 'Dr. Lombardi Franco',
    diagnosi: 'Neoplasia mammaria con metastasi ossee',
    comorbidita: ['Osteoporosi severa', 'Ipertensione arteriosa', 'Diabete Tipo 2'],
    fragilitaAI: { punteggio: 92, livello: 'Critico', colore: '#EF4444' },
    cia: 'CIA-4',
    tipoPAI: 'Cure Palliative',
    provider: 'Fondazione Hospice Roma Sud',
    paiSteps: [
      { label: 'Presa in Carico', stato: 'completato', data: '03/02/2026', operatore: 'Seg. Martini' },
      { label: 'Valutazione UVM', stato: 'completato', data: '05/02/2026', operatore: 'Dr. Ferri' },
      { label: 'Definizione PAI', stato: 'completato', data: '08/02/2026', operatore: 'CM Baldi' },
      { label: 'Assegnazione Operatore', stato: 'corrente', data: '18/02/2026', operatore: 'In corso' },
      { label: 'Attivazione PAI', stato: 'futuro', data: null, operatore: null },
    ],
  },
  8: {
    id: 8,
    nome: 'Ricci',
    cognome: 'Marco',
    sesso: 'M',
    eta: 68,
    dataNascita: '22/03/1957',
    codiceFiscale: 'RCCMRC57C22H501A',
    residenza: 'Via Appia Nuova 85, Roma',
    telefono: '+39 06 5551234',
    medico: 'Dr.ssa Conti Lucia',
    diagnosi: 'Ictus ischemico emisfero sinistro',
    comorbidita: ['Fibrillazione atriale', 'Disfagia moderata'],
    fragilitaAI: { punteggio: 78, livello: 'Alto', colore: '#F97316' },
    cia: 'CIA-3',
    tipoPAI: 'Riab. Neurologica',
    provider: 'Coop. Riabilita Roma',
    paiSteps: [
      { label: 'Presa in Carico', stato: 'completato', data: '05/02/2026', operatore: 'Seg. Rossi' },
      { label: 'Valutazione UVM', stato: 'completato', data: '07/02/2026', operatore: 'Dr. Ferri' },
      { label: 'Definizione PAI', stato: 'corrente', data: '18/02/2026', operatore: 'In corso' },
      { label: 'Assegnazione Operatore', stato: 'futuro', data: null, operatore: null },
      { label: 'Attivazione PAI', stato: 'futuro', data: null, operatore: null },
      { label: 'Rivalutazione PAI', stato: 'futuro', data: null, operatore: null },
      { label: 'Scadenza PAI', stato: 'futuro', data: null, operatore: null },
    ],
    paiStatus: 'DA_COMPLETARE_CM',
    uvmdNotes: {
      inquadramento: 'Paziente post-ictus ischemico con emiparesi sinistra residua. Livello di coscienza conservato. Barthel Index 30/100. Necessita riabilitazione intensiva domiciliare con supporto infermieristico e logopedico.',
      obiettivi: 'Obiettivo primario: recupero motorio arto superiore e deambulazione assistita entro 90 gg. Obiettivo secondario: miglioramento disfagia (GUSS > 18/20) e ripresa comunicazione verbale. Monitoraggio TAO e prevenzione recidiva.',
    },
  },
  3: {
    id: 3,
    nome: 'Verdi',
    cognome: 'Anna',
    sesso: 'F',
    eta: 81,
    dataNascita: '09/11/1944',
    codiceFiscale: 'VRDNNA44S49H501B',
    residenza: 'Viale Europa 44, Roma',
    telefono: '+39 06 9988776',
    medico: 'Dr. Marchetti Paolo',
    diagnosi: 'Frattura femore destro post-caduta',
    comorbidita: ['Artrosi diffusa', 'Osteoporosi', 'Deficit visivo'],
    fragilitaAI: { punteggio: 85, livello: 'Alto', colore: '#F97316' },
    cia: 'CIA-2',
    tipoPAI: 'Riab. Ortopedica',
    provider: 'ASL Roma 2 — Fisioterapia Domiciliare',
    paiSteps: [
      { label: 'Presa in Carico', stato: 'completato', data: '01/02/2026', operatore: 'Seg. Martini' },
      { label: 'Valutazione UVM', stato: 'completato', data: '03/02/2026', operatore: 'Dr. Bianchi' },
      { label: 'Definizione PAI', stato: 'completato', data: '05/02/2026', operatore: 'CM Baldi' },
      { label: 'Assegnazione Operatore', stato: 'completato', data: '06/02/2026', operatore: 'Ft. Galli' },
      { label: 'Attivazione PAI', stato: 'completato', data: '18/02/2026', operatore: 'Completato' },
      { label: 'Rivalutazione PAI', stato: 'corrente', data: '10/03/2026', operatore: 'In corso' },
      { label: 'Scadenza PAI', stato: 'futuro', data: '22/03/2026', operatore: null },
    ],
  },
  1: {
    id: 1,
    nome: 'Rossi',
    cognome: 'Maria',
    sesso: 'F',
    eta: 76,
    dataNascita: '30/01/1950',
    codiceFiscale: 'RSSMRA50A70H501C',
    residenza: 'Via dei Castani 18, Roma',
    telefono: '+39 06 3344556',
    medico: 'Dr. Esposito Gennaro',
    diagnosi: 'BPCO riacutizzata con insufficienza respiratoria',
    comorbidita: ['Scompenso cardiaco NYHA III', 'Anemia cronica'],
    fragilitaAI: { punteggio: 88, livello: 'Critico', colore: '#EF4444' },
    cia: 'CIA-1',
    tipoPAI: 'Infermieristica',
    provider: 'Coop. Cuore di San Camillo',
    paiSteps: [
      { label: 'Presa in Carico', stato: 'completato', data: '08/02/2026', operatore: 'Seg. Belli' },
      { label: 'Valutazione UVM', stato: 'completato', data: '10/02/2026', operatore: 'Dr. Ferri' },
      { label: 'Definizione PAI', stato: 'corrente', data: '18/02/2026', operatore: 'In corso' },
      { label: 'Assegnazione Operatore', stato: 'futuro', data: null, operatore: null },
      { label: 'Attivazione PAI', stato: 'futuro', data: null, operatore: null },
      { label: 'Rivalutazione PAI', stato: 'futuro', data: null, operatore: null },
      { label: 'Scadenza PAI', stato: 'futuro', data: null, operatore: null },
    ],
  },
  4: {
    id: 4,
    nome: 'Esposito',
    cognome: 'Luca',
    sesso: 'M',
    eta: 64,
    dataNascita: '17/08/1961',
    codiceFiscale: 'SPSLCU61M17H501D',
    residenza: 'Via Casilina 200, Roma',
    telefono: '+39 06 7712345',
    medico: 'Dr.ssa Neri Chiara',
    diagnosi: 'Insufficienza renale cronica stadio IV',
    comorbidita: ['Ipertensione severa', 'Neuropatia periferica', 'Diabete Tipo 2'],
    fragilitaAI: { punteggio: 71, livello: 'Moderato', colore: '#EAB308' },
    cia: 'CIA-3',
    tipoPAI: 'Inferm. Avanzata',
    provider: 'Consorzio Salus',
    paiSteps: [
      { label: 'Presa in Carico', stato: 'completato', data: '02/02/2026', operatore: 'Seg. Martini' },
      { label: 'Valutazione UVM', stato: 'completato', data: '04/02/2026', operatore: 'Dr. Bianchi' },
      { label: 'Definizione PAI', stato: 'completato', data: '07/02/2026', operatore: 'CM Baldi' },
      { label: 'Assegnazione Operatore', stato: 'completato', data: '09/02/2026', operatore: 'Inf. Colombo' },
      { label: 'Attivazione PAI', stato: 'corrente', data: '18/02/2026', operatore: 'In corso' },
      { label: 'Rivalutazione PAI', stato: 'futuro', data: '15/03/2026', operatore: null },
      { label: 'Scadenza PAI', stato: 'futuro', data: '30/03/2026', operatore: null },
    ],
  },
};

/* ========================================
   PAI Builder — Dati AI e InterRAI
   ======================================== */
export const paiBuilderData = {
  7: {
    interraiFindings: [
      { area: 'Dolore', livello: 'critico', dettaglio: 'NRS 8/10 — Dolore oncologico non controllato dalla terapia orale', raccomandazione: 'Passaggio a terapia antalgica di III livello (oppioidi maggiori)' },
      { area: 'Nutrizione', livello: 'severo', dettaglio: 'BMI 17.2 — Calo ponderale > 5% ultimo mese, disfagia lieve', raccomandazione: 'Integrazione nutrizionale orale, consulenza dietologica' },
      { area: 'Mobilita', livello: 'severo', dettaglio: 'ADL: dipendente per trasferimenti e igiene personale', raccomandazione: 'Supporto OSS per igiene, mobilizzazione passiva' },
      { area: 'Cute', livello: 'moderato', dettaglio: 'CVC in sede — segni iniziali di flogosi peristomale', raccomandazione: 'Medicazione CVC ogni 48h con protocollo asettico' },
      { area: 'Stato Cognitivo', livello: 'lieve', dettaglio: 'CPS 1 — Lieve deficit di memoria recente', raccomandazione: 'Monitoraggio, nessun intervento specifico' },
    ],
    aiSuggestion: {
      modello: 'ADI-ClinicalAI v2.4',
      confidenza: 89,
      generatoIl: '18/02/2026 09:30',
      interventi: [
        { professionista: 'Infermiere', frequenza: '3 accessi/sett.', prestazione: 'Medicazione CVC, somministrazione terapia antalgica, monitoraggio parametri vitali' },
        { professionista: 'Medico Palliativista', frequenza: '1 accesso/sett.', prestazione: 'Rivalutazione terapia del dolore, gestione sintomi' },
        { professionista: 'OSS', frequenza: '5 accessi/sett.', prestazione: 'Igiene personale, supporto alimentazione, mobilizzazione' },
        { professionista: 'Fisioterapista', frequenza: '2 accessi/sett.', prestazione: 'Mobilizzazione passiva, prevenzione sindrome da immobilizzazione' },
      ],
      durata: '60 giorni',
      note: 'PAI ad alta complessita (CIA-4). Si raccomanda rivalutazione a 30 giorni per adeguamento terapia antalgica.',
    },
  },
  8: {
    interraiFindings: [
      { area: 'Mobilita', livello: 'critico', dettaglio: 'Emiplegia destra — dipendente per deambulazione e trasferimenti', raccomandazione: 'FKT intensiva, ausili per deambulazione' },
      { area: 'Comunicazione', livello: 'severo', dettaglio: 'Afasia di Broca moderata — comprensione conservata', raccomandazione: 'Logopedia 2x/settimana' },
      { area: 'Deglutizione', livello: 'moderato', dettaglio: 'Disfagia ai liquidi — dieta semiliquida in corso', raccomandazione: 'Addensanti, monitoraggio rischio ab-ingestis' },
      { area: 'Stato Emotivo', livello: 'moderato', dettaglio: 'DRS 3 — Umore depresso, ridotta partecipazione', raccomandazione: 'Supporto psicologico, attivita occupazionale' },
    ],
    aiSuggestion: {
      modello: 'ADI-ClinicalAI v2.4',
      confidenza: 82,
      generatoIl: '18/02/2026 09:15',
      interventi: [
        { professionista: 'Fisioterapista', frequenza: '3 accessi/sett.', prestazione: 'Riabilitazione motoria arto superiore e inferiore, training deambulazione' },
        { professionista: 'Logopedista', frequenza: '2 accessi/sett.', prestazione: 'Riabilitazione linguaggio, esercizi deglutizione' },
        { professionista: 'Infermiere', frequenza: '2 accessi/sett.', prestazione: 'Monitoraggio parametri, gestione terapia anticoagulante' },
        { professionista: 'OSS', frequenza: '3 accessi/sett.', prestazione: 'Igiene personale, supporto ADL' },
      ],
      durata: '90 giorni',
      note: 'Profilo riabilitativo intensivo. Rivalutazione funzionale prevista a 45 giorni.',
    },
  },
  3: {
    interraiFindings: [
      { area: 'Mobilita', livello: 'critico', dettaglio: 'Post-intervento frattura femore dx — carico parziale consentito', raccomandazione: 'FKT progressiva con carico incrementale' },
      { area: 'Cadute', livello: 'severo', dettaglio: 'Storia di cadute ricorrenti (3 episodi/6 mesi), deficit visivo', raccomandazione: 'Valutazione ambiente domiciliare, rimozione ostacoli' },
      { area: 'Dolore', livello: 'moderato', dettaglio: 'NRS 5/10 — Dolore post-chirurgico controllato', raccomandazione: 'Terapia analgesica di I-II livello' },
    ],
    aiSuggestion: {
      modello: 'ADI-ClinicalAI v2.4',
      confidenza: 91,
      generatoIl: '18/02/2026 08:45',
      interventi: [
        { professionista: 'Fisioterapista', frequenza: '3 accessi/sett.', prestazione: 'Riabilitazione post-chirurgica, rinforzo muscolare, training equilibrio' },
        { professionista: 'Infermiere', frequenza: '1 accesso/sett.', prestazione: 'Medicazione ferita chirurgica, monitoraggio guarigione' },
        { professionista: 'OSS', frequenza: '3 accessi/sett.', prestazione: 'Igiene, supporto mobilizzazione, supervisione deambulazione' },
      ],
      durata: '45 giorni',
      note: 'Obiettivo: recupero deambulazione autonoma con ausilio. Buona prognosi riabilitativa.',
    },
  },
  1: {
    interraiFindings: [
      { area: 'Respirazione', livello: 'critico', dettaglio: 'SpO2 88% in aria ambiente — O2 terapia 2L/min in corso', raccomandazione: 'Monitoraggio saturimetrico, gestione O2 terapia domiciliare' },
      { area: 'Cuore', livello: 'severo', dettaglio: 'Scompenso cardiaco NYHA III — edemi declivi bilaterali', raccomandazione: 'Monitoraggio peso, bilancio idrico, terapia diuretica' },
      { area: 'Mobilita', livello: 'moderato', dettaglio: 'Dispnea da sforzo — ridotta autonomia funzionale', raccomandazione: 'Mobilizzazione cauta, esercizi respiratori' },
      { area: 'Nutrizione', livello: 'lieve', dettaglio: 'Anemia cronica Hb 9.8 — dieta iperproteica consigliata', raccomandazione: 'Supplementazione ferro, monitoraggio emocromo' },
    ],
    aiSuggestion: {
      modello: 'ADI-ClinicalAI v2.4',
      confidenza: 85,
      generatoIl: '18/02/2026 10:00',
      interventi: [
        { professionista: 'Infermiere', frequenza: '3 accessi/sett.', prestazione: 'Monitoraggio SpO2, PA, FC, gestione O2 terapia, prelievi ematici' },
        { professionista: 'Fisioterapista', frequenza: '1 accesso/sett.', prestazione: 'Riabilitazione respiratoria, esercizi di espansione toracica' },
        { professionista: 'OSS', frequenza: '2 accessi/sett.', prestazione: 'Igiene personale, supporto alimentazione' },
      ],
      durata: '30 giorni',
      note: 'Paziente fragile. Monitoraggio ravvicinato necessario. Rivalutazione precoce a 15 giorni.',
    },
  },
  4: {
    interraiFindings: [
      { area: 'Funzione Renale', livello: 'critico', dettaglio: 'eGFR 18 mL/min — IRC stadio IV, candidato a dialisi', raccomandazione: 'Preparazione accesso vascolare, consulenza nefrologica' },
      { area: 'Neuropatia', livello: 'severo', dettaglio: 'Neuropatia periferica arti inferiori — rischio ulcere', raccomandazione: 'Ispezione quotidiana piedi, calzature appropriate' },
      { area: 'Metabolismo', livello: 'moderato', dettaglio: 'HbA1c 8.2% — Controllo glicemico subottimale', raccomandazione: 'Ottimizzazione terapia insulinica, educazione alimentare' },
    ],
    aiSuggestion: {
      modello: 'ADI-ClinicalAI v2.4',
      confidenza: 87,
      generatoIl: '18/02/2026 09:50',
      interventi: [
        { professionista: 'Infermiere', frequenza: '3 accessi/sett.', prestazione: 'Monitoraggio parametri renali, glicemia, PA, gestione accesso vascolare' },
        { professionista: 'Dietista', frequenza: '1 accesso/sett.', prestazione: 'Piano alimentare ipoproteico per IRC, gestione dieta diabetica' },
        { professionista: 'OSS', frequenza: '2 accessi/sett.', prestazione: 'Igiene, ispezione piedi, supporto ADL' },
      ],
      durata: '60 giorni',
      note: 'Preparazione percorso pre-dialitico. Coordinamento con U.O. Nefrologia per timing accesso.',
    },
  },
};

export const paiTimelines = [
  {
    pazienteId: 7,
    pazienteNome: 'Ferrara Elena',
    cia: 'CIA-4',
    tipo: 'Cure Palliative',
    inizioPAI: 3,
    durataGiorni: 28,
    stato: 'attivo',
    colore: '#8B5CF6',
    percentualeCompletamento: 55,
  },
  {
    pazienteId: 8,
    pazienteNome: 'Ricci Marco',
    cia: 'CIA-3',
    tipo: 'Riab. Neurologica',
    inizioPAI: 5,
    durataGiorni: 25,
    stato: 'attivo',
    colore: '#06B6D4',
    percentualeCompletamento: 40,
  },
  {
    pazienteId: 3,
    pazienteNome: 'Verdi Anna',
    cia: 'CIA-2',
    tipo: 'Riab. Ortopedica',
    inizioPAI: 1,
    durataGiorni: 22,
    stato: 'in_scadenza',
    colore: '#F59E0B',
    percentualeCompletamento: 85,
  },
  {
    pazienteId: 1,
    pazienteNome: 'Rossi Maria',
    cia: 'CIA-1',
    tipo: 'Infermieristica',
    inizioPAI: 8,
    durataGiorni: 20,
    stato: 'attivo',
    colore: '#10B981',
    percentualeCompletamento: 25,
  },
  {
    pazienteId: 4,
    pazienteNome: 'Esposito Luca',
    cia: 'CIA-3',
    tipo: 'Inferm. Avanzata',
    inizioPAI: 2,
    durataGiorni: 28,
    stato: 'attivo',
    colore: '#EC4899',
    percentualeCompletamento: 65,
  },
];


/* ========================================
   Gantt Clinico-Logistico — Mock Data
   ======================================== */
export const ganttData = {
  7: {
    giorni: 28,
    meseLabel: 'Febbraio 2026',
    oggi: 18,
    prestazioni: {
      infermiere: {
        label: 'Infermiere',
        colore: '#06B6D4',
        accessi: [
          { giorno: 10, stato: 'erogata', nota: 'Medicazione CVC eseguita', parametri: 'PA 130/80, SpO2 94%', geo: 'Via Tuscolana 312' },
          { giorno: 12, stato: 'erogata', nota: 'Somministrazione terapia antalgica IV', parametri: 'NRS 5/10 post-somm.', geo: 'Via Tuscolana 312' },
          { giorno: 14, stato: 'erogata', nota: 'Medicazione CVC + prelievo ematico', parametri: 'PA 125/78, SpO2 93%', geo: 'Via Tuscolana 312' },
          { giorno: 17, stato: 'mancata', nota: 'Accesso mancato', motivo: 'Paziente trasferita in PS per dispnea acuta' },
          { giorno: 19, stato: 'pianificata', nota: 'Medicazione CVC programmata', geo: 'Via Tuscolana 312' },
          { giorno: 21, stato: 'pianificata', nota: 'Somministrazione terapia antalgica IV', geo: 'Via Tuscolana 312' },
          { giorno: 24, stato: 'pianificata', nota: 'Medicazione CVC + prelievo ematico', geo: 'Via Tuscolana 312' },
          { giorno: 26, stato: 'pianificata', nota: 'Monitoraggio parametri vitali', geo: 'Via Tuscolana 312' },
        ],
      },
      fisioterapista: {
        label: 'Fisioterapista',
        colore: '#8B5CF6',
        accessi: [
          { giorno: 11, stato: 'erogata', nota: 'Mobilizzazione passiva arti inferiori', parametri: 'ROM ginocchio: 60 gradi', geo: 'Via Tuscolana 312' },
          { giorno: 14, stato: 'erogata', nota: 'Esercizi respiratori + posturale', parametri: 'Barthel Index: 25/100', geo: 'Via Tuscolana 312' },
          { giorno: 18, stato: 'pianificata', nota: 'Mobilizzazione passiva arti inferiori', geo: 'Via Tuscolana 312' },
          { giorno: 21, stato: 'pianificata', nota: 'Esercizi respiratori + posturale', geo: 'Via Tuscolana 312' },
          { giorno: 25, stato: 'pianificata', nota: 'Rinforzo muscolare progressivo', geo: 'Via Tuscolana 312' },
        ],
      },
      oss: {
        label: 'OSS',
        colore: '#F59E0B',
        accessi: [
          { giorno: 10, stato: 'erogata', nota: 'Igiene personale completa', parametri: null, geo: 'Via Tuscolana 312' },
          { giorno: 11, stato: 'erogata', nota: 'Igiene + cambio biancheria', parametri: null, geo: 'Via Tuscolana 312' },
          { giorno: 12, stato: 'erogata', nota: 'Igiene + supporto alimentazione', parametri: null, geo: 'Via Tuscolana 312' },
          { giorno: 13, stato: 'erogata', nota: 'Igiene personale', parametri: null, geo: 'Via Tuscolana 312' },
          { giorno: 14, stato: 'erogata', nota: 'Igiene + mobilizzazione assistita', parametri: null, geo: 'Via Tuscolana 312' },
          { giorno: 15, stato: 'mancata', nota: 'Accesso mancato', motivo: 'Operatore malattia — non sostituito' },
          { giorno: 17, stato: 'erogata', nota: 'Igiene personale', parametri: null, geo: 'Via Tuscolana 312' },
          { giorno: 18, stato: 'pianificata', nota: 'Igiene personale completa', geo: 'Via Tuscolana 312' },
          { giorno: 19, stato: 'pianificata', nota: 'Igiene + cambio biancheria', geo: 'Via Tuscolana 312' },
          { giorno: 20, stato: 'pianificata', nota: 'Igiene + supporto alimentazione', geo: 'Via Tuscolana 312' },
          { giorno: 21, stato: 'pianificata', nota: 'Igiene personale', geo: 'Via Tuscolana 312' },
          { giorno: 22, stato: 'pianificata', nota: 'Igiene + mobilizzazione assistita', geo: 'Via Tuscolana 312' },
        ],
      },
    },
    telemonitoraggio: {
      spo2: {
        label: 'SpO2',
        unita: '%',
        soglia: { min: 92 },
        valori: [
          { giorno: 10, valore: 94 }, { giorno: 11, valore: 93 }, { giorno: 12, valore: 91 },
          { giorno: 13, valore: 92 }, { giorno: 14, valore: 93 }, { giorno: 15, valore: 88 },
          { giorno: 16, valore: 90 }, { giorno: 17, valore: 89 }, { giorno: 18, valore: 91 },
        ],
      },
      pressione: {
        label: 'PA Sist.',
        unita: 'mmHg',
        soglia: { max: 160 },
        valori: [
          { giorno: 10, valore: 130 }, { giorno: 12, valore: 125 }, { giorno: 14, valore: 140 },
          { giorno: 16, valore: 155 }, { giorno: 17, valore: 165 }, { giorno: 18, valore: 150 },
        ],
      },
      peso: {
        label: 'Peso',
        unita: 'kg',
        soglia: { min: 50, max: 65 },
        valori: [
          { giorno: 10, valore: 52 }, { giorno: 14, valore: 51.5 }, { giorno: 18, valore: 51 },
        ],
      },
    },
    versioning: [
      { giorno: 8, versione: 'V1.0', tipo: 'creazione' },
    ],
    scadenzaPAI: 28,
    rivalutazione: 22,
    outcomes: [
      { giorno: 10, tipo: 'caregiver', label: 'Conferma presenza', completato: true },
      { giorno: 13, tipo: 'caregiver', label: 'Conferma farmaci', completato: true },
      { giorno: 15, tipo: 'proms', label: 'ESAS compilato', completato: true },
      { giorno: 17, tipo: 'caregiver', label: 'Conferma presenza', completato: true },
      { giorno: 20, tipo: 'prems', label: 'Questionario soddisfazione', completato: false },
      { giorno: 25, tipo: 'proms', label: 'ESAS follow-up', completato: false },
    ],
  },
  8: {
    giorni: 28, meseLabel: 'Febbraio 2026', oggi: 18,
    prestazioni: {
      fisioterapista: { label: 'Fisioterapista', colore: '#8B5CF6', accessi: [
        { giorno: 7, stato: 'erogata', nota: 'Valutazione iniziale motoria', parametri: 'Barthel 30/100', geo: 'Via Appia Nuova 85' },
        { giorno: 9, stato: 'erogata', nota: 'FKT arto superiore dx', parametri: 'ROM spalla: 45 gradi', geo: 'Via Appia Nuova 85' },
        { giorno: 11, stato: 'erogata', nota: 'Training deambulazione', parametri: '10m con deambulatore', geo: 'Via Appia Nuova 85' },
        { giorno: 14, stato: 'erogata', nota: 'FKT + equilibrio', parametri: 'Tinetti 12/28', geo: 'Via Appia Nuova 85' },
        { giorno: 16, stato: 'erogata', nota: 'Mobilizzazione progressiva', parametri: null, geo: 'Via Appia Nuova 85' },
        { giorno: 18, stato: 'pianificata', nota: 'FKT arto superiore dx', geo: 'Via Appia Nuova 85' }, { giorno: 20, stato: 'pianificata', nota: 'Training deambulazione', geo: 'Via Appia Nuova 85' }, { giorno: 23, stato: 'pianificata', nota: 'Mobilizzazione progressiva + equilibrio', geo: 'Via Appia Nuova 85' },
      ]},
      logopedista: { label: 'Logopedista', colore: '#EC4899', accessi: [
        { giorno: 8, stato: 'erogata', nota: 'Valutazione disfagia + afasia', parametri: 'GUSS 14/20', geo: 'Via Appia Nuova 85' },
        { giorno: 12, stato: 'erogata', nota: 'Esercizi articolazione', parametri: null, geo: 'Via Appia Nuova 85' },
        { giorno: 15, stato: 'erogata', nota: 'Training deglutizione', parametri: 'GUSS 16/20', geo: 'Via Appia Nuova 85' },
        { giorno: 19, stato: 'pianificata', nota: 'Esercizi articolazione + naming', geo: 'Via Appia Nuova 85' }, { giorno: 22, stato: 'pianificata', nota: 'Training deglutizione', geo: 'Via Appia Nuova 85' },
      ]},
      infermiere: { label: 'Infermiere', colore: '#06B6D4', accessi: [
        { giorno: 7, stato: 'erogata', nota: 'Monitoraggio parametri + INR', parametri: 'INR 2.3, PA 140/85', geo: 'Via Appia Nuova 85' },
        { giorno: 10, stato: 'erogata', nota: 'Controllo TAO', parametri: 'INR 2.1', geo: 'Via Appia Nuova 85' },
        { giorno: 14, stato: 'erogata', nota: 'Prelievo + parametri', parametri: 'PA 135/80, Temp 37.8', geo: 'Via Appia Nuova 85' },
        { giorno: 17, stato: 'erogata', nota: 'Monitoraggio febbre', parametri: 'Temp 37.2, PA 130/78', geo: 'Via Appia Nuova 85' },
        { giorno: 20, stato: 'pianificata', nota: 'Controllo TAO + parametri', geo: 'Via Appia Nuova 85' }, { giorno: 24, stato: 'pianificata', nota: 'Prelievo ematico programmato', geo: 'Via Appia Nuova 85' },
      ]},
      oss: { label: 'OSS', colore: '#F59E0B', accessi: [
        { giorno: 7, stato: 'erogata', nota: 'Igiene + vestizione', parametri: null, geo: 'Via Appia Nuova 85' },
        { giorno: 9, stato: 'erogata', nota: 'Igiene', parametri: null, geo: 'Via Appia Nuova 85' },
        { giorno: 11, stato: 'erogata', nota: 'Igiene + pasto assistito', parametri: null, geo: 'Via Appia Nuova 85' },
        { giorno: 14, stato: 'erogata', nota: 'Igiene', parametri: null, geo: 'Via Appia Nuova 85' },
        { giorno: 16, stato: 'erogata', nota: 'Igiene + mobilizzazione', parametri: null, geo: 'Via Appia Nuova 85' },
        { giorno: 18, stato: 'pianificata', nota: 'Igiene + vestizione', geo: 'Via Appia Nuova 85' }, { giorno: 20, stato: 'pianificata', nota: 'Igiene + pasto assistito', geo: 'Via Appia Nuova 85' }, { giorno: 22, stato: 'pianificata', nota: 'Igiene personale', geo: 'Via Appia Nuova 85' },
      ]},
    },
    telemonitoraggio: {
      spo2: { label: 'SpO2', unita: '%', soglia: { min: 92 }, valori: [
        { giorno: 7, valore: 96 }, { giorno: 9, valore: 95 }, { giorno: 11, valore: 96 },
        { giorno: 14, valore: 95 }, { giorno: 16, valore: 97 }, { giorno: 18, valore: 96 },
      ]},
      pressione: { label: 'PA Sist.', unita: 'mmHg', soglia: { max: 160 }, valori: [
        { giorno: 7, valore: 140 }, { giorno: 10, valore: 135 }, { giorno: 14, valore: 150 },
        { giorno: 17, valore: 130 }, { giorno: 18, valore: 128 },
      ]},
      peso: { label: 'Peso', unita: 'kg', soglia: { min: 65, max: 85 }, valori: [
        { giorno: 7, valore: 78 }, { giorno: 14, valore: 77.5 }, { giorno: 18, valore: 77 },
      ]},
    },
    versioning: [{ giorno: 7, versione: 'V1.0', tipo: 'creazione' }],
    scadenzaPAI: 28, rivalutazione: 24,
    outcomes: [
      { giorno: 8, tipo: 'caregiver', label: 'Conferma presenza', completato: true },
      { giorno: 12, tipo: 'proms', label: 'BI compilato', completato: true },
      { giorno: 18, tipo: 'caregiver', label: 'Feedback settimanale', completato: false },
      { giorno: 24, tipo: 'prems', label: 'Questionario qualita', completato: false },
    ],
  },
  3: {
    giorni: 28, meseLabel: 'Febbraio 2026', oggi: 18,
    prestazioni: {
      fisioterapista: { label: 'Fisioterapista', colore: '#8B5CF6', accessi: [
        { giorno: 6, stato: 'erogata', nota: 'Valutazione iniziale post-chirurgica', parametri: 'Barthel 35/100', geo: 'Viale Europa 44' },
        { giorno: 8, stato: 'erogata', nota: 'Mobilizzazione cauta arto operato', parametri: 'ROM anca: 40 gradi', geo: 'Viale Europa 44' },
        { giorno: 10, stato: 'erogata', nota: 'Esercizi isometrici + deambulazione assistita', parametri: '5m con deambulatore', geo: 'Viale Europa 44' },
        { giorno: 13, stato: 'erogata', nota: 'Training equilibrio + rinforzo quadricipite', parametri: 'Tinetti 10/28', geo: 'Viale Europa 44' },
        { giorno: 15, stato: 'erogata', nota: 'Deambulazione progressiva', parametri: '15m con deambulatore', geo: 'Viale Europa 44' },
        { giorno: 17, stato: 'erogata', nota: 'FKT completa + scale', parametri: 'Barthel 50/100', geo: 'Viale Europa 44' },
        { giorno: 19, stato: 'pianificata', nota: 'Deambulazione progressiva con deambulatore', geo: 'Viale Europa 44' }, { giorno: 21, stato: 'pianificata', nota: 'FKT completa + esercizi scale', geo: 'Viale Europa 44' }, { giorno: 24, stato: 'pianificata', nota: 'Rinforzo quadricipite + equilibrio', geo: 'Viale Europa 44' },
      ]},
      infermiere: { label: 'Infermiere', colore: '#06B6D4', accessi: [
        { giorno: 7, stato: 'erogata', nota: 'Medicazione ferita chirurgica', parametri: 'Ferita in ordine, no segni infezione', geo: 'Viale Europa 44' },
        { giorno: 11, stato: 'erogata', nota: 'Controllo ferita + parametri vitali', parametri: 'PA 140/85, T 36.5', geo: 'Viale Europa 44' },
        { giorno: 14, stato: 'erogata', nota: 'Rimozione punti + medicazione', parametri: 'Guarigione regolare', geo: 'Viale Europa 44' },
        { giorno: 18, stato: 'pianificata', nota: 'Controllo ferita chirurgica', geo: 'Viale Europa 44' }, { giorno: 22, stato: 'pianificata', nota: 'Monitoraggio parametri vitali', geo: 'Viale Europa 44' },
      ]},
      oss: { label: 'OSS', colore: '#F59E0B', accessi: [
        { giorno: 6, stato: 'erogata', nota: 'Igiene personale + vestizione', parametri: null, geo: 'Viale Europa 44' },
        { giorno: 8, stato: 'erogata', nota: 'Igiene + mobilizzazione assistita', parametri: null, geo: 'Viale Europa 44' },
        { giorno: 10, stato: 'erogata', nota: 'Igiene', parametri: null, geo: 'Viale Europa 44' },
        { giorno: 12, stato: 'mancata', nota: 'Accesso mancato', motivo: 'Paziente in visita ortopedica' },
        { giorno: 13, stato: 'erogata', nota: 'Igiene + supporto deambulazione', parametri: null, geo: 'Viale Europa 44' },
        { giorno: 15, stato: 'erogata', nota: 'Igiene personale', parametri: null, geo: 'Viale Europa 44' },
        { giorno: 17, stato: 'erogata', nota: 'Igiene + supervisione scale', parametri: null, geo: 'Viale Europa 44' },
        { giorno: 19, stato: 'pianificata', nota: 'Igiene personale + vestizione', geo: 'Viale Europa 44' }, { giorno: 21, stato: 'pianificata', nota: 'Igiene + mobilizzazione assistita', geo: 'Viale Europa 44' }, { giorno: 23, stato: 'pianificata', nota: 'Igiene + supporto deambulazione', geo: 'Viale Europa 44' },
      ]},
    },
    telemonitoraggio: {
      pressione: { label: 'PA Sist.', unita: 'mmHg', soglia: { max: 150 }, valori: [
        { giorno: 7, valore: 140 }, { giorno: 11, valore: 135 }, { giorno: 14, valore: 145 },
        { giorno: 18, valore: 138 },
      ]},
      peso: { label: 'Peso', unita: 'kg', soglia: { min: 55, max: 70 }, valori: [
        { giorno: 7, valore: 62 }, { giorno: 14, valore: 62.5 }, { giorno: 18, valore: 63 },
      ]},
    },
    versioning: [{ giorno: 5, versione: 'V1.0', tipo: 'creazione' }],
    scadenzaPAI: 22, rivalutazione: 20,
    outcomes: [
      { giorno: 8, tipo: 'caregiver', label: 'Conferma presenza', completato: true },
      { giorno: 13, tipo: 'proms', label: 'Barthel Index', completato: true },
      { giorno: 18, tipo: 'caregiver', label: 'Feedback settimanale', completato: false },
      { giorno: 22, tipo: 'prems', label: 'Questionario soddisfazione', completato: false },
    ],
  },
  4: {
    giorni: 28, meseLabel: 'Febbraio 2026', oggi: 18,
    prestazioni: {
      infermiere: { label: 'Infermiere', colore: '#06B6D4', accessi: [
        { giorno: 9, stato: 'erogata', nota: 'Monitoraggio parametri renali + glicemia', parametri: 'Creatinina 4.2, Glic 180', geo: 'Via Casilina 200' },
        { giorno: 11, stato: 'erogata', nota: 'Gestione accesso vascolare FAV', parametri: 'Thrill presente', geo: 'Via Casilina 200' },
        { giorno: 13, stato: 'erogata', nota: 'Prelievo + monitoraggio PA', parametri: 'PA 155/90, K+ 5.1', geo: 'Via Casilina 200' },
        { giorno: 15, stato: 'erogata', nota: 'Controllo glicemia + insulina', parametri: 'Glic 165, HbA1c 8.0', geo: 'Via Casilina 200' },
        { giorno: 17, stato: 'erogata', nota: 'Monitoraggio completo', parametri: 'PA 148/88, eGFR 19', geo: 'Via Casilina 200' },
        { giorno: 19, stato: 'pianificata', nota: 'Monitoraggio parametri renali + glicemia', geo: 'Via Casilina 200' }, { giorno: 21, stato: 'pianificata', nota: 'Gestione accesso vascolare FAV', geo: 'Via Casilina 200' }, { giorno: 24, stato: 'pianificata', nota: 'Prelievo + monitoraggio PA', geo: 'Via Casilina 200' },
      ]},
      oss: { label: 'OSS', colore: '#F59E0B', accessi: [
        { giorno: 9, stato: 'erogata', nota: 'Igiene + ispezione piedi', parametri: null, geo: 'Via Casilina 200' },
        { giorno: 12, stato: 'erogata', nota: 'Igiene personale', parametri: null, geo: 'Via Casilina 200' },
        { giorno: 14, stato: 'erogata', nota: 'Igiene + cura piedi', parametri: null, geo: 'Via Casilina 200' },
        { giorno: 16, stato: 'erogata', nota: 'Igiene + supporto ADL', parametri: null, geo: 'Via Casilina 200' },
        { giorno: 18, stato: 'pianificata', nota: 'Igiene + ispezione piedi', geo: 'Via Casilina 200' }, { giorno: 20, stato: 'pianificata', nota: 'Igiene personale', geo: 'Via Casilina 200' },
      ]},
    },
    telemonitoraggio: {
      pressione: { label: 'PA Sist.', unita: 'mmHg', soglia: { max: 150 }, valori: [
        { giorno: 9, valore: 155 }, { giorno: 11, valore: 148 }, { giorno: 13, valore: 160 },
        { giorno: 15, valore: 152 }, { giorno: 17, valore: 148 },
      ]},
      peso: { label: 'Peso', unita: 'kg', soglia: { min: 70, max: 90 }, valori: [
        { giorno: 9, valore: 82 }, { giorno: 14, valore: 81.5 }, { giorno: 18, valore: 81 },
      ]},
    },
    versioning: [{ giorno: 7, versione: 'V1.0', tipo: 'creazione' }],
    scadenzaPAI: 28, rivalutazione: 25,
    outcomes: [
      { giorno: 10, tipo: 'caregiver', label: 'Conferma presenza', completato: true },
      { giorno: 14, tipo: 'proms', label: 'Questionario qualita vita', completato: true },
      { giorno: 20, tipo: 'caregiver', label: 'Feedback dieta', completato: false },
      { giorno: 26, tipo: 'prems', label: 'PREMs nefrologico', completato: false },
    ],
  },
};
